import React from 'react';
import { MenuItem } from '@material-ui/core';
import TextField from 'components/TextField';
import { Container, Row, Column, WrapperInputCustom } from './styles';

function LoadInfo({ formik, setConvocationType, edit, view }) {
  const onChangeConvocationType = (e) => {
    const value = e.target.value;
    setConvocationType(value);
    formik.setFieldValue('type_convocation', value);
  };

  return (
    <Container>
      <Row>
        <Column>
          <WrapperInputCustom>
            <TextField
              label="Data Início da Viagem"
              name="data_inicio_viagem"
              type="date"
              value={
                formik.values.data_inicio_viagem instanceof Date
                  ? formik.values.data_inicio_viagem.toISOString().split('T')[0]
                  : formik.values.data_inicio_viagem
                    ? typeof formik.values.data_inicio_viagem === 'string'
                      ? formik.values.data_inicio_viagem.split('T')[0]
                      : formik.values.data_inicio_viagem
                    : ''
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.data_inicio_viagem && Boolean(formik.errors.data_inicio_viagem)}
              helperText={formik.touched.data_inicio_viagem && formik.errors.data_inicio_viagem}
              disabled={view}
              fullWidth
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </WrapperInputCustom>
        </Column>

        <Column>
          <WrapperInputCustom>
            <TextField
              label="Validade da Carga"
              name="validity"
              type="date"
              value={
                formik.values.validity instanceof Date
                  ? formik.values.validity.toISOString().split('T')[0]
                  : formik.values.validity
                    ? typeof formik.values.validity === 'string'
                      ? formik.values.validity.split('T')[0]
                      : formik.values.validity
                    : ''
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.validity && Boolean(formik.errors.validity)}
              helperText={formik.touched.validity && formik.errors.validity}
              disabled={view}
              fullWidth
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </WrapperInputCustom>
        </Column>

        <Column>
          <WrapperInputCustom>
            <TextField
              label="Carga"
              name="type_convocation"
              select
              value={formik.values.type_convocation || ''}
              onChange={onChangeConvocationType}
              onBlur={formik.handleBlur}
              disabled={view}
              fullWidth
              color="secondary"
            >
              <MenuItem value="public">Pública</MenuItem>
              <MenuItem value="private">Privada</MenuItem>
            </TextField>
          </WrapperInputCustom>
        </Column>
      </Row>
    </Container>
  );
}

export default LoadInfo;
